angular.module('com.vmware.vsphere.client.host')
   .constant("maintenanceModeConstants", {
      EVACUATE_ALL_DATA: "evacuateAllData",
      ENSURE_OBJECT_ACCESSIBILITY: "ensureObjectAccessibility",
      NO_ACTION: "noAction"
   });
